import React from "react";
import "./Vireya1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Vyorelleimages from "../../../Media/BSD/Vireya/Vyorelle";
import Lynelleimages from "../../../Media/BSD/Vireya/Lynelle";

const imageMap = {
  Vyorelleimages,
  Lynelleimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Vireya" className="vireya">
      <h1>Our Home</h1>
      <h2>Cicilan Start 6 Juta/Bulan</h2>
      <div className="cardhome-container">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
